var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 39,
    viewBox: "0 0 51 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00012207 32.2146H1.3208L2.10378 36.0507H2.16856L3.17967 32.2118H4.50059L5.5117 36.0507H5.57648L6.35101 32.2118H7.64095L6.31158 37.918H4.94841L3.87252 33.7186H3.80774L2.73185 37.918H1.30672L-0.00012207 32.2146Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4995 32.2146H11.9077L14.1243 37.9207H12.7555L12.2964 36.7068H10.015L9.56723 37.9207H8.23785L10.4995 32.2146ZM11.9077 35.7126L11.167 33.7411H11.1022L10.3671 35.7126H11.9077Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5494 32.2146H16.7887V36.8279H19.6502V37.9207H15.5494V32.2146Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8437 35.6789H26.0886C26.0886 37.2364 25.1113 38.0278 23.5538 38.0278C22.1287 38.0278 20.8472 37.1829 20.8472 35.2395V34.8959C20.8472 32.9413 22.1287 32.1076 23.5538 32.1076C25.1028 32.1076 26.0886 32.9075 26.0886 34.3608H24.8437V34.2228C24.8099 33.6341 24.4438 33.1948 23.5707 33.1948C22.6103 33.1948 22.1625 33.6764 22.1625 34.6959V35.4113C22.1625 36.4309 22.6046 36.9125 23.5707 36.9125C24.4438 36.9125 24.8015 36.4872 24.8437 35.8028V35.6789Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8063 32.2146H33.0512V37.9207H31.8035V35.5239H29.0715V37.9207H27.8323V32.2146H29.0715V34.4396H31.8035L31.8063 32.2146Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7463 32.2146H38.1545L40.3739 37.9207H39.0051L38.5488 36.7068H36.2647L35.8169 37.9207H34.4875L36.7463 32.2146ZM38.1545 35.7126L37.411 33.7411H37.3462L36.6139 35.7126H38.1545Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7963 32.2146H43.0356V37.9207H41.7963V32.2146Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9728 32.2146H46.3811L48.8849 35.9971H48.9412V32.2146H50.1889V37.9207H48.7807L46.2881 34.1382H46.2234V37.9207H44.9841L44.9728 32.2146Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6818 1.32772L31.3745 1.50516L37.7819 12.6032L38.0892 12.4258L31.6818 1.32772Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5274 23.4357H18.7125V23.7905H31.5274V23.4357Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5634 1.33044L12.154 12.4274L12.4613 12.6049L18.8707 1.50793L18.5634 1.33044Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5274 1.23914H18.7125V1.59401H31.5274V1.23914Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8654 1.32772L18.5581 1.50516L24.9656 12.6032L25.2729 12.4258L18.8654 1.32772Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9345 12.3389H12.3047V12.6937H37.9345V12.3389Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3871 0.770516L24.9797 11.9195L25.2884 12.0969L31.6959 0.947953L31.3871 0.770516Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7125 2.83321C19.4949 2.83321 20.1292 2.19894 20.1292 1.41653C20.1292 0.634117 19.4949 -0.000152588 18.7125 -0.000152588C17.9301 -0.000152588 17.2958 0.634117 17.2958 1.41653C17.2958 2.19894 17.9301 2.83321 18.7125 2.83321Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5273 2.83321C32.3097 2.83321 32.944 2.19894 32.944 1.41653C32.944 0.634117 32.3097 -0.000152588 31.5273 -0.000152588C30.7449 -0.000152588 30.1106 0.634117 30.1106 1.41653C30.1106 2.19894 30.7449 2.83321 31.5273 2.83321Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6176 12.3307L31.212 23.4299L31.8268 23.7847L38.2323 12.6855L37.6176 12.3307Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6128 12.3374L11.9981 12.6923L18.4056 23.7903L19.0202 23.4354L12.6128 12.3374Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4289 12.3401L24.8142 12.695L31.2217 23.7931L31.8363 23.4382L25.4289 12.3401Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8045 12.3329L18.399 23.4321L19.0137 23.7869L25.4192 12.6877L24.8045 12.3329Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6935 15.7214C14.4637 15.7214 15.8987 14.2864 15.8987 12.5163C15.8987 10.7461 14.4637 9.31116 12.6935 9.31116C10.9234 9.31116 9.4884 10.7461 9.4884 12.5163C9.4884 14.2864 10.9234 15.7214 12.6935 15.7214Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9376 15.7214C39.7077 15.7214 41.1427 14.2864 41.1427 12.5163C41.1427 10.7461 39.7077 9.31116 37.9376 9.31116C36.1674 9.31116 34.7324 10.7461 34.7324 12.5163C34.7324 14.2864 36.1674 15.7214 37.9376 15.7214Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5273 26.8182C33.2975 26.8182 34.7325 25.3832 34.7325 23.6131C34.7325 21.8429 33.2975 20.408 31.5273 20.408C29.7572 20.408 28.3222 21.8429 28.3222 23.6131C28.3222 25.3832 29.7572 26.8182 31.5273 26.8182Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7125 26.8182C20.4826 26.8182 21.9176 25.3832 21.9176 23.6131C21.9176 21.8429 20.4826 20.408 18.7125 20.408C16.9423 20.408 15.5073 21.8429 15.5073 23.6131C15.5073 25.3832 16.9423 26.8182 18.7125 26.8182Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1198 14.5385C26.2366 14.5385 27.142 13.6332 27.142 12.5163C27.142 11.3995 26.2366 10.4941 25.1198 10.4941C24.0029 10.4941 23.0975 11.3995 23.0975 12.5163C23.0975 13.6332 24.0029 14.5385 25.1198 14.5385Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP5);
export default __webpack_public_path__ + "static/media/p5.16a69a46a5bb3a2a26f4fefa23de6aad.svg";
export { ForwardRef as ReactComponent };